import mfmHomeImage from "@/assets/mfm-home-1.webp";
import { Container } from "../atoms/Container";
import { Eyebrow } from "../atoms/Eyebrow";
import { PhotoPlaceholder } from "../atoms/PhotoPlaceholder";

type SitePromiseProps = {
  mobile?: boolean;
};

export function SitePromise({ mobile = false }: SitePromiseProps) {
  const pad = mobile ? 24 : 96;
  return (
    <section
      style={{
        paddingTop: mobile ? 72 : 128,
        paddingBottom: mobile ? 72 : 128,
      }}
    >
      <Container pad={pad}>
        <PhotoPlaceholder
          src={mfmHomeImage}
          alt="A runner from behind on a quiet road at sunrise."
          caption="low-sun road · one runner from behind, blurred"
          height={mobile ? 280 : 520}
          horizon={0.62}
          parallax
          objectPosition={mobile ? "72% center" : "68% center"}
          sizes="(max-width: 768px) calc(100vw - 48px), 928px"
        />

        <div
          style={{
            marginTop: mobile ? 48 : 80,
            display: "grid",
            gridTemplateColumns: mobile ? "1fr" : "minmax(0,5fr) minmax(0,7fr)",
            gap: mobile ? 28 : 80,
            alignItems: "start",
          }}
        >
          <Eyebrow>What this is</Eyebrow>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: mobile ? 20 : 28,
              maxWidth: 600,
            }}
          >
            <p
              style={{
                margin: 0,
                fontFamily: "var(--ui)",
                fontSize: mobile ? 18 : 20,
                lineHeight: 1.55,
                color: "var(--text)",
                letterSpacing: "-0.005em",
              }}
            >
              Most people who try this don&apos;t have a coach. They have a PDF, a podcast, and a
              lot of doubt.
            </p>
            <p
              style={{
                margin: 0,
                fontFamily: "var(--ui)",
                fontSize: mobile ? 18 : 20,
                lineHeight: 1.55,
                color: "var(--text)",
                letterSpacing: "-0.005em",
              }}
            >
              You&apos;ll have a plan that adapts to your week, your body, and your life.{" "}
              <em
                style={{
                  fontFamily: "var(--display)",
                  fontStyle: "italic",
                  color: "var(--text)",
                }}
              >
                Eighteen weeks. Forty-six runs. One marathon.
              </em>
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
}
